import { Box, Text } from "@mantine/core";

interface GroupLogoProps {
  name: string;
  size?: number;
}

// Shared abbreviation function
const getAbbreviation = (name: string) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("");
};

export const GroupLogo = ({ name, size = 48 }: GroupLogoProps) => {
  return (
    <Box
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "var(--mantine-color-blue-6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <Text fw="bold" style={{ fontSize: size * 0.4 }}>
        {getAbbreviation(name)}
      </Text>
    </Box>
  );
};
